import { styled } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';

export const FormContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
  width: '320px',
  maxWidth: '100%',
  boxSizing: 'border-box',
  alignItems: 'stretch',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.75),
    width: '100%',
    maxWidth: '320px',
  },
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(0.5),
  },
}));

export const FormRow = styled(Stack)(({ theme }) => ({
  width: '100%',
  alignItems: 'stretch',
  '& .MuiTextField-root': {
    width: '100%',
    minWidth: 0,
    margin: 0,
    '& .MuiInputBase-root': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      width: '100%',
    },
  },
  '& > div:not(.MuiTextField-root)': {
    maxWidth: '100%',
    width: '100%',
    transform: 'scale(0.77)',
    transformOrigin: 'center top',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      transform: 'scale(0.85)',
    },
    [theme.breakpoints.down('xs')]: {
      transform: 'scale(0.9)',
    },
  },
}));

export const FormHeader = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  textAlign: 'center',
  width: '100%',
  marginBottom: theme.spacing(1),
}));

export const HelperText = styled(Typography)(({ theme }) => ({
  fontSize: '0.85rem',
  color: theme.palette.text.secondary,
  textAlign: 'center',
  width: '100%',
}));

export const ActionsRow = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(1),
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  gap: theme.spacing(1),
}));

export const FeedbackContainer = styled('div')(({ hasFeedback }) => ({
  minHeight: hasFeedback ? 'auto' : '1px',
}));
